import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { useTranslations } from 'next-intl';

import TeaserContainer from '../teaser-container/teaserContainer';
import Pagination from '../pagination/pagination';
import Container from '../../layout/container/container';
import Download from '../../molecules/download/download';

import StyledTagFilterResults from './tagFilterResults.style';
import LoadingIndicator from '../../atoms/loading-indicator/loadingIndicator';

const TagFilterResults = ({
  isLoading = false,
  error = false,
  listEntries,
  listType,
  filteredValues,
  pagination
}) => {
  const t = useTranslations();
  if (listEntries === null) return null; // prevent errors down below

  const isDownload = listType === 'downloads';

  const renderListEntries = data =>
    isDownload ? (
      <Container>
        {data.map(item => (
          <Download {...item} key={item.id} />
        ))}
      </Container>
    ) : (
      <TeaserContainer data={data} topMargin={pagination ? pagination.current_page > 1 : false} />
    );

  return (
    <StyledTagFilterResults isVisible={!isLoading} id="tag-filter-results">
      {error && <div className="tag-filter-results__error">{t('filter.error')}</div>}

      {/* Show loading skeleton */}
      {isLoading && (
        <div className="tag-filter-results__loading">
          <LoadingIndicator inverted />
        </div>
      )}

      {/* Check if listEntries array isnt empty else show no results message */}
      {!isLoading && listEntries.length > 0 && renderListEntries(listEntries)}

      {!isLoading && listEntries.length === 0 && (
        <div className="tag-filter-results__no-results">{t('filter.noResults')}</div>
      )}

      {pagination && pagination.total_pages > 1 && (
        <Pagination
          filters={filteredValues}
          totalPages={parseInt(pagination.total_pages, 10)}
          currentPage={parseInt(pagination.current_page, 10)}
        />
      )}
    </StyledTagFilterResults>
  );
};

TagFilterResults.propTypes = {
  listType: PropTypes.oneOf(['downloads', 'events', 'articles']).isRequired,
  slug: PropTypes.string.isRequired,
  pagination: PropTypes.shape(),
  filteredValues: PropTypes.arrayOf(PropTypes.string),
  isLoading: PropTypes.bool,
  error: PropTypes.bool,
  listEntries: PropTypes.arrayOf(PropTypes.shape())
};

const mapStateToProps = state => {
  const { filter, app } = state;

  return {
    filteredValues: filter.filteredTags,
    listEntries: app.pageData.listData?.data ?? null,
    pagination: app.pageData.listData?.meta ? app.pageData.listData.meta.pagination : null,
    listType: app.pageData.listType,
    slug: app.pageData.slug,
    isLoading: filter.isLoading,
    error: filter.error
  };
};

export default connect(mapStateToProps)(TagFilterResults);
